import React from "react";
import IconComponent from "../Icons/IconComponent";

const StatusPairing = ({ colorStatusPairing, onClick, iconStatusPairing }) => {
    return (
        <div
            className="status-pairing"
            style={{ background: colorStatusPairing }}
            onClick={onClick}
        >
            <IconComponent nameIcon={iconStatusPairing}/>
        </div>
    );
};

export default StatusPairing;
